module.exports = __webpack_public_path__ + "media/public/images/logo-aae6614a513716f07165b571a6e85375.svg";